import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {IOfferListingParams} from "../types/OfferListingParams";

export function useOffersMapUrl() {
    const {search} = useLocation();
    //  TODO: Add credit 2% handling and remove ts ignore below
    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useParams<IOfferListingParams>();

    const parsedSearch = parseSearch(search);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {page, sort, sol, ...validSearch} = parsedSearch;

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        const abroadMapLink = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;
        return appendQueryString(
            abroadMapLink({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);
        const query = {
            ...validSearch,
            ...subFilterQuery
        };
        return appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendQueryString(
            rpAppLink.offer.mapFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiListMap(), validSearch);
}
import {useLocation, useParams} from "react-router";

import {appendQueryString, parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {getOfferListSubFilterParsed} from "../helpers/friendly_offer_list/get_offer_list_sub_filter_parsed";
import {getCountryId} from "../list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {IOfferListingParams} from "../types/OfferListingParams";

export function useOffersMapUrl() {
    const {search} = useLocation();
    //  TODO: Add credit 2% handling and remove ts ignore below
    const {friendlySlug, offerListSubFilter, offerListSubType, abroadRegionSlug, country} = useParams<IOfferListingParams>();

    const parsedSearch = parseSearch(search);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {page, sort, sol, ...validSearch} = parsedSearch;

    if (friendlySlug && country && getCountryId(country) !== Country.POLAND) {
        const abroadMapLink = abroadRegionSlug ? rpAppLink.offer.mapAbroadRegion : rpAppLink.offer.mapAbroadCountry;
        return appendQueryString(
            abroadMapLink({
                friendlySlug,
                country,
                abroadRegionSlug
            }),
            validSearch
        );
    }

    if (friendlySlug && offerListSubFilter) {
        const subFilterQuery = getOfferListSubFilterParsed(offerListSubFilter);
        const query = {
            ...validSearch,
            ...subFilterQuery
        };
        return appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), query);
    }

    if (friendlySlug && offerListSubType) {
        return appendQueryString(
            rpAppLink.offer.mapFriendlySubType({
                friendlySlug,
                offerListSubType
            }),
            validSearch
        );
    }

    if (friendlySlug) {
        return appendQueryString(rpAppLink.offer.mapFriendly({friendlySlug}), validSearch);
    }

    return appendQueryString(rpAppLink.offer.multiListMap(), validSearch);
}
